import posthog from 'posthog-js';

const NO_AUTH_PAGES = ['/signin', '/unsubscribe'];

export default defineNuxtRouteMiddleware(async (to) => {
    if (NO_AUTH_PAGES.some(url => to.path.includes(url))) return;

    const { $client } = useNuxtApp();
    const router = useRouter();
    await $client.auth.refreshToken.mutate().then((data) => {
        posthog.identify(`${data.userId}`, {
            email: data.email,
        });
    }).catch(async () => {
        await $client.auth.signout.mutate().finally(() => {
            router.push("/signin")
        })
    })
})
